export default __webpack_public_path__ + "static/media/dataEngineerTheme.8cfae376.png";